import React from "react";
import { MESSAGE_TAG_ACTIONS } from "../../../enum";
import CreateCannedResponseModal from "../CannedResponseHeader/CreateCannedResponseModal/CreateCannedResponseModal";
import ConfirmationModal from "components/dashboard/common/ConfirmationModal/ConfirmationModal";
import { apiRoute } from "services";

const { EDIT, DELETE } = MESSAGE_TAG_ACTIONS;

const CannedResponseActionModals = ({
    cannedResponse,
    currentAction,
    closeModal,
    handleSuccess,
}) => {
    const renderBasedOnAction = () => {
        switch (currentAction) {
            case EDIT:
                return (
                    <CreateCannedResponseModal
                        cannedResponse={cannedResponse}
                        showModal={true}
                        closeModal={closeModal}
                        handleSuccess={handleSuccess}
                        currentAction={currentAction}
                    />
                );

            case DELETE:
                return (
                    <ConfirmationModal
                        title={`Are you sure you want to delete ${cannedResponse?.title}`}
                        show={true}
                        closeModal={closeModal}
                        handleSuccess={handleSuccess}
                        url={apiRoute.editCannedResponse(
                            cannedResponse?.cannedResponseId
                        )}
                        method='delete'
                    />
                );
            default:
                return "";
        }
    };
    return <>{renderBasedOnAction()}</>;
};

export default CannedResponseActionModals;
